import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=5b73b58b&"
import script from "./emailTemplate.vue?vue&type=script&lang=js&"
export * from "./emailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports